import { VAppLayoutManager } from './VAppLayoutManager';

export default VAppLayoutManager;